// extracted by mini-css-extract-plugin
export default {"Header":"ImportCarriersDialog_Header__UjWUA","Panel":"ImportCarriersDialog_Panel__7MB-i"};